import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HotelController, { AreaType, RoomType } from '../controller/HotelController';

const DeviceList = (props: any) => {
  const { deviceList, setAreaList, refresh, editingRoom, disableCondition, selectType } = props;
  const [clickedRoom, setClickedRoom] = useState<number[]>([]);
  const buttonClick = (roomId: number) => {
    if (selectType === 'onlyOne') {
      setClickedRoom([roomId]);
    } else {
      if (clickedRoom.includes(roomId)) {
        setClickedRoom(clickedRoom.filter((i) => i !== roomId));
      } else {
        setClickedRoom([...clickedRoom, roomId]);
      }
    }
  };
  const listAllSelect = () => {
    if (selectType === 'onlyOne') return;
    const roomIds = deviceList
      ?.flatMap((area: AreaType) =>
        area.room.filter((room: RoomType) =>
          disableCondition ? room.area_grade_id === null : true,
        ),
      )
      .map((room: RoomType) => room.area_id);

    const allSelected = roomIds.every((id: number) => clickedRoom.includes(id));

    if (allSelected) {
      setClickedRoom(clickedRoom.filter((id) => !roomIds.includes(id)));
    } else {
      setClickedRoom([
        ...clickedRoom,
        ...roomIds.filter((id: number) => !clickedRoom.includes(id)),
      ]);
    }
  };
  const roomAllSelect = (rooms: RoomType[]) => {
    if (selectType === 'onlyOne') return;
    const roomIds = rooms
      .filter((room) => (disableCondition ? room.area_grade_id === null : true))
      .map((room) => room.area_id);

    const allSelected = roomIds.every((id: number) => clickedRoom.includes(id));

    if (allSelected) {
      setClickedRoom(clickedRoom.filter((id) => !roomIds.includes(id)));
    } else {
      setClickedRoom([
        ...clickedRoom,
        ...roomIds.filter((id: number) => !clickedRoom.includes(id)),
      ]);
    }
  };

  useEffect(() => {
    setAreaList(clickedRoom);
  }, [clickedRoom]);
  useEffect(() => {
    setClickedRoom([]);
  }, [refresh]);
  
  useEffect(() => {
    if (deviceList && editingRoom) {
      const matchingRooms = deviceList
        ?.flatMap((area: AreaType) =>
          area.room.filter(
            (room: RoomType) => room.area_grade_name === editingRoom.area_grade_name,
          ),
        )
        .map((room: RoomType) => room.area_id);

      setClickedRoom(matchingRooms);
    }
  }, [deviceList, editingRoom]);

  return (
    <Style>
      <div className="DeviceListWrap">
        <label className={`checkboxWrap ${selectType === 'onlyOne' && "displayNone"}`}>
          <p>객실 전체 선택</p>
          <input
            type="checkbox"
            className="checkbox"
            onChange={() => listAllSelect()}
            checked={deviceList
              ?.flatMap((area: AreaType) =>
                area.room.filter((room: RoomType) => room.area_grade_id === null),
              )
              .map((room: RoomType) => room.area_id)
              .every((id: number) => clickedRoom.includes(id))}
          />
        </label>
        {deviceList &&
          deviceList.map((area: AreaType, index: number) => (
            <div key={index} className="deviceBox">
              <div className="deviceHeader">
                <p>{area.area_name} </p>
                <label className={`checkboxWrap ${selectType === 'onlyOne' && "displayNone"}`}>
                  <p>전체</p>
                  <input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => roomAllSelect(area.room)}
                    checked={area.room.every((room) => clickedRoom.includes(room.area_id))}
                  />
                </label>
              </div>
              <div className="deviceList">
                {area.room.map((room: RoomType) => (
                  <button
                    key={room.area_id}
                    onClick={() => buttonClick(room.area_id)}
                    disabled={
                      disableCondition &&
                      room.area_grade_id !== null &&
                      room.area_grade_name !== editingRoom?.area_grade_name
                    }
                    className={`roomButton ${
                      disableCondition &&
                      room.area_grade_id !== null &&
                      room.area_grade_name !== editingRoom?.area_grade_name
                        ? 'disabled'
                        : `${clickedRoom.includes(room.area_id) ? 'active' : 'unActive'}`
                    }`}>
                    <div>
                      <p>{room.name}</p>
                    </div>
                    <div className="checkIcon">
                      {clickedRoom.includes(room.area_id) && (
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_check_white.svg`}
                          alt="check아이콘"
                        />
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ))}
      </div>
    </Style>
  );
};

export default DeviceList;

const Style = styled.div`
  p {
    font-size: 16px;
    font-weight: 500;
    color: #555;
  }

  .deviceHeader {
    padding: 13px 35px;
    background: #f7f7f7;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      flex: 1;
      text-align: center;
    }
  }
  .checkboxWrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    gap: 7px;
    cursor: pointer;

    p {
      font-size: 14px;
    }
  }
  .checkboxWrap.displayNone {
    display: none;
  }
  .checkbox {
    width: 18px;
    height: 18px;
    margin: 0;
    border-radius: 3px;
    accent-color: #40977f;
  }

  .deviceBox {
    margin-top: 18px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
  }
  .deviceList {
    width: 100%;
    padding: 22px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2%;

    .roomButton {
      width: 18%;
      height: 100%;
      margin-top: 7px;
      display: flex;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-radius: 5px;
    }
    .roomButton > div {
      background: #fff;
    }
    .roomButton > div:nth-child(1) {
      flex: 1;
      padding: 10px 0;
      border-radius: 5px;
      border: 1px solid #4dd2ae;
      margin: -1px;
    }
    .roomButton > div:nth-child(2) {
      background: #f7f7f7;
      flex: 0 0 20%;
    }
    .roomButton.disabled {
      background: #cecece;
      border: 1px solid #cecece;
      cursor: not-allowed;
    }
    .roomButton.disabled > div:nth-child(1) {
      border: 1px solid #cecece;
    }
    .roomButton.disabled p {
      color: #cecece;
    }
    .roomButton.active {
      background: #4dd2ae;
    }
    .roomButton.unActive {
      background: #f7f7f7;
    }
  }
  .checkIcon {
    background: none !important;
    display: flex;
    align-self: center;
    justify-content: center;
  }

  @media (max-width: 500px) {
    .deviceList {
      padding: 22px 10px;
      gap: 1%;
      .roomButton {
        width: 24%;
        background: red;
      }
    }
  }
`;
